export default __webpack_public_path__ + "static/media/email.21b1a031.svg";